
// // import React from "react";

// // const WhyCommunityApp = () => {
// //   const points = [
// //     { icon: "bi-telephone-inbound", title: "All-in-One Platform", desc: "Replace scattered WhatsApp groups and manual spreadsheets." },
// //     { icon: "bi-lock", title: "Secure & Compliant", desc: "Role-based access, audit logs, and privacy by design." },
// //     { icon: "bi-speedometer2", title: "Fast & Reliable", desc: "Real-time updates, optimized performance, and uptime SLAs." },
// //     { icon: "bi-people", title: "Resident Engagement", desc: "Events, polls, forums, and feedback loops that drive community." },
// //   ];
// //   return (
// //     <section id="why" className="py-5">
// //       <div className="container">
// //         <div className="text-center mb-4">
// //           <h2 className="fw-bold text-primary-label">Why Choose Lupie Service App?</h2>
// //           <p className="text-muted">Built for gated communities, RWAs, and housing societies.</p>
// //         </div>
// //         <div className="row g-4">
// //           {points.map((p, i) => (
// //             <div key={i} className="col-12 col-sm-6 col-lg-3">
// //               <div className="card h-100 border-0">
// //                 <div className="card-body text-center">
// //                   <i className={`bi ${p.icon} text-primary-label fs-1`} aria-hidden="true"></i>
// //                   <h5 className="mt-3">{p.title}</h5>
// //                   <p className="text-muted">{p.desc}</p>
// //                 </div>
// //               </div>
// //             </div>
// //           ))}
// //         </div>
// //       </div>
// //     </section>
// //   );
// // };

// // export default WhyCommunityApp;

// import React from "react";
// import "./why.mobile.css"; // <-- tiny CSS helper for the mobile rail

// const WhyCommunityApp = () => {
//   const points = [
//     {
//       icon: "bi-telephone-inbound",
//       title: "All-in-One Platform",
//       desc: "Replace scattered WhatsApp groups and manual spreadsheets.",
//     },
//     {
//       icon: "bi-lock",
//       title: "Secure & Compliant",
//       desc: "Role-based access, audit logs, and privacy by design.",
//     },
//     {
//       icon: "bi-speedometer2",
//       title: "Fast & Reliable",
//       desc: "Real-time updates, optimized performance, and uptime SLAs.",
//     },
//     {
//       icon: "bi-people",
//       title: "Resident Engagement",
//       desc: "Events, polls, forums, and feedback loops that drive community.",
//     },
//   ];

//   return (
//     <section id="why" className="py-5">
//       <div className="container">
//         <div className="text-center mb-4">
//           <h2 className="fw-bold text-primary-label">Why Choose Lupie Service App?</h2>
//           <p className="text-muted">
//             Built for gated communities, RWAs, and housing societies.
//           </p>
//         </div>

//         {/* --- MOBILE (< md): horizontally scrollable icon cards --- */}
//         <div className="d-md-none">
//           <div className="why-rail" aria-label="Why Lupie Service App">
//             {points.map((p, i) => (
//               <article key={i} className="why-card" role="listitem">
//                 <div className="why-icon-wrap" aria-hidden="true">
//                   <i className={`bi ${p.icon} why-icon`}></i>
//                 </div>
//                 <h5 className="why-title">{p.title}</h5>
//                 <p className="why-desc text-muted">{p.desc}</p>
//               </article>
//             ))}
//           </div>
//         </div>

//         {/* --- DESKTOP/TABLET (>= md): original Bootstrap grid --- */}
//         <div className="row g-4 d-none d-md-flex">
//           {points.map((p, i) => (
//             <div key={i} className="col-12 col-sm-6 col-lg-3">
//               <div className="card h-100 border-0">
//                 <div className="card-body text-center">
//                   <i className={`bi ${p.icon} text-primary-label fs-1`} aria-hidden="true"></i>
//                   <h5 className="mt-3">{p.title}</h5>
//                   <p className="text-muted">{p.desc}</p>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>

//       </div>
//     </section>
//   );
// };

// export default WhyCommunityApp;

import React, { useState } from "react";
import "./why.mobile.css"; // <-- add this CSS file (see below)

const WhyCommunityApp = () => {
  const points = [
    {
      icon: "bi-telephone-inbound",
      title: "All-in-One Platform",
      desc: "Replace scattered WhatsApp groups and manual spreadsheets.",
    },
    {
      icon: "bi-lock",
      title: "Secure & Compliant",
      desc: "Role-based access, audit logs, and privacy by design.",
    },
    {
      icon: "bi-speedometer2",
      title: "Fast & Reliable",
      desc: "Real-time updates, optimized performance, and uptime SLAs.",
    },
    {
      icon: "bi-people",
      title: "Resident Engagement",
      desc: "Events, polls, forums, and feedback loops that drive community.",
    },
  ];

  // Track flip state per card (for mobile grid)
  const [flipped, setFlipped] = useState(() => points.map(() => false));
  const toggleFlip = (i) =>
    setFlipped((prev) => prev.map((f, idx) => (idx === i ? !f : f)));

  return (
    <section id="why" className="py-5">
      <div className="container">
        <div className="text-center mb-4">
          <h2 className="fw-bold text-primary-label">Why Choose Lupie Service App?</h2>
          <p className="text-muted">
            Built for gated communities, RWAs, and housing societies.
          </p>
        </div>

        {/* --- MOBILE (< md): 2×N grid with flip animation cards --- */}
        <div className="d-md-none">
          <div className="why-grid" aria-label="Why Lupie Service App">
            {points.map((p, i) => (
              <button
                key={p.title}
                type="button"
                className={`flip-card ${flipped[i] ? "is-flipped" : ""}`}
                onClick={() => toggleFlip(i)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    toggleFlip(i);
                  }
                }}
                aria-expanded={flipped[i]}
                aria-label={`${p.title} details`}
              >
                <div className="flip-card-inner">
                  {/* FRONT */}
                  <div className="flip-card-face flip-card-front">
                    <div className="why-icon-wrap text-primary-label" aria-hidden="true">
                      <i className={`bi ${p.icon} why-icon`} />
                    </div>
                    <h5 className="why-title">{p.title}</h5>
                  </div>

                  {/* BACK */}
                  <div className="flip-card-face flip-card-back">
                    <h6 className="why-back-title">{p.title}</h6>
                    <p className="why-desc text-muted">{p.desc}</p>
                    <span className="hint">Tap to flip back</span>
                  </div>
                </div>
              </button>
            ))}
          </div>
        </div>

        {/* --- DESKTOP/TABLET (>= md): original Bootstrap grid --- */}
        <div className="row g-4 d-none d-md-flex">
          {points.map((p, i) => (
            <div key={i} className="col-12 col-sm-6 col-lg-3">
              <div className="card h-100 border-0">
                <div className="card-body text-center">
                  <i className={`bi ${p.icon} text-primary-label fs-1`} aria-hidden="true"></i>
                  <h5 className="mt-3">{p.title}</h5>
                  <p className="text-muted">{p.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default WhyCommunityApp;
